import type {
  WebsiteStylesInterface,
  WebsiteThemeForSaveInterface,
  WebsiteThemeInterface,
} from 'src/shared/types/website-settings-types'
import { transformWebsiteStylesForApi } from '../website/utils/transform-website-styles-for-api'
import { transformWebsiteTheme } from '../website/utils/transform-website-theme'

export const useTransformWebsiteSettingsForSave = ({
  websiteStyles,
  websiteTheme,
}: {
  websiteStyles?: WebsiteStylesInterface
  websiteTheme?: WebsiteThemeInterface | null
}):
  | {
      style?: WebsiteStylesInterface
      theme?: WebsiteThemeForSaveInterface
    }
  | undefined => {
  const resolvedTheme = websiteTheme ?? undefined

  if (!websiteStyles && !resolvedTheme) {
    return
  }

  return {
    style: websiteStyles
      ? transformWebsiteStylesForApi(websiteStyles)
      : undefined,
    theme: resolvedTheme ? transformWebsiteTheme(resolvedTheme) : undefined,
  }
}
